import type {ApiErrorResponse} from '../services/http.ts';

export class LoadResourceError extends Error {
	response: ApiErrorResponse;

	constructor(message: string, apiResponse: ApiErrorResponse) {
		super(message);
		this.name = 'LoadResourceError';
		this.response = apiResponse;
	}
}
